import _ from 'lodash';

import type { Brand } from 'src/gql/graphql';

type GetBrandProps = {
  brands: Brand[];
  brandId: string;
};

type GetBrandReturn = {
  brand: Brand | null;
};

export const getBrand = ({ brands, brandId }: GetBrandProps): GetBrandReturn => {
  const brand = _.find(brands, (curr) => _.kebabCase(curr.name) === brandId || curr.id === brandId) ?? null;
  return {
    brand,
  };
};
